// Script unificato per rimuovere prodotti refill dal carrello
(function() {
    'use strict';
    
    const PRODUCTS_TO_REMOVE = [
        '10267510014298',
        '49696704561498',
        '49703241646426',
        '49703631159642',
        '51521429143898',
        '51537432772954',
        '39852206162025',
        '51546518913370',
        '51560813265242',
        '51561132327258',
        '32409387303017',
        '40508719857769'
    ];
    
    function cleanupCart() {
        // Prima controlla il carrello corrente via fetch per essere sicuri
        fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(cart => {
                const updates = {};
                let hasUpdates = false;
                
                // Controlla tutti gli item nel carrello
                cart.items.forEach(item => {
                    if (PRODUCTS_TO_REMOVE.includes(String(item.variant_id))) {
                        updates[item.variant_id] = 0;
                        hasUpdates = true;
                        console.log(`Prodotto da rimuovere trovato: ${item.variant_id}`);
                    }
                });
                
                if (hasUpdates) {
                    console.log('Rimozione prodotti dal carrello...', updates);
                    
                    return fetch(window.Shopify.routes.root + 'cart/update.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        body: JSON.stringify({ updates })
                    });
                }
                return null;
            })
            .then(response => {
                if (response) {
                    if (response.redirected) {
                        window.location.href = response.url;
                        return;
                    }
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                }
                return null;
            })
            .then(cart => {
                if (cart) {
                    console.log('Carrello aggiornato:', cart);
                    
                    // Aggiorna i contatori
                    const cartCountElements = document.querySelectorAll('[data-cart-count]');
                    cartCountElements.forEach(element => {
                        element.textContent = cart.item_count;
                    });
                    
                    // Rimuovi gli elementi dal DOM se esistono
                    PRODUCTS_TO_REMOVE.forEach(variantId => {
                        const cartItem = document.querySelector(`[data-id="${variantId}"]`);
                        if (cartItem) {
                            cartItem.style.transition = 'opacity 0.3s ease';
                            cartItem.style.opacity = '0';
                            setTimeout(() => cartItem.remove(), 300);
                        }
                    });
                    
                    // Ricarica dopo un breve delay per mostrare le animazioni
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                }
                //  else {
                //     console.log('Nessun prodotto da rimuovere trovato');
                // }
            })
            .catch(error => {
                console.error('Errore durante la pulizia del carrello:', error);
                // Ricarica comunque in caso di errore
                // window.location.reload();
            });
    }
    
    // Avvia la pulizia quando il DOM è pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', cleanupCart);
    } else {
        cleanupCart();
    }
    
    // Esponi la funzione globalmente per uso manuale se necessario
    window.cleanupCart = cleanupCart;
})();